import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { FAQS } from './salesData';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="bg-cream py-14 sm:py-20" data-id="element-100" data-mp="1bmd8ncjfgm7p">
      <div className="mx-auto max-w-2xl px-5" data-id="element-101" data-mp="1gitwe5mpsyk9">
        <h2 className="text-center font-display text-[1.6rem] font-extrabold tracking-tight text-charcoal sm:text-[2.2rem]" data-id="element-102" data-mp="1glpubtykbn8p">
          Preguntas frecuentes
        </h2>

        <div className="mt-8 space-y-2.5" data-id="element-103" data-mp="289hvzd8qpvvt">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <div key={i} className="overflow-hidden rounded-2xl border border-stone bg-white shadow-[0_10px_30px_-26px_rgba(56,37,34,0.5)]" data-id="element-104" data-mp="1uhk2ubvfcala" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-105" data-mp="2n5z6k293v6hb">
                  <span className="font-display text-[0.92rem] font-semibold leading-snug text-charcoal sm:text-[1rem]" data-id="element-106" data-mp="10rvu92p248mt">
                    {faq.q}
                  </span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden strokeWidth={3} data-id="element-107" data-mp="19stwbffxq62r" />
                </button>
                <AnimatePresence initial={false} data-id="element-108" data-mp="1xhv9th3mk7ew">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-109" data-mp="1slo3hn7bgtwf">
                      <p className="px-5 pb-5 font-sans text-[0.87rem] leading-relaxed text-taupe" data-id="element-110" data-mp="237ei40ty9wfw">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}